import React from 'react';
import cn from 'classnames';

import SearchModel from 'coreClasses/search/SearchModel';
import {useLocation, useSearchMgrInstance} from 'coreHooks';
import {useCategory, useParentCategoryTree} from 'coreHooks/categories';
import {PageType} from 'coreUtils/IUtils';

import {IBreadcrumbsProps} from './IBreadcrumbs';
import CategoryBreadcrumbs, {Breadcrumb} from './Subcomponents';

import styles from './Breadcrumbs.module.scss';

const Breadcrumbs = ({
	product,
	prefixItems = [],
	cgid,
	showProductName = true,
	lastCategoryLabelVariant
}: IBreadcrumbsProps) => {
	const searchMgr = useSearchMgrInstance();
	const searchModel: SearchModel = searchMgr.getStoredSearchModel();
	const category = useCategory(product?.getPrimaryCategoryId() || searchModel?.getSelectedRefinements()?.cgid || cgid);
	const parentCategoryTree = useParentCategoryTree(category);
	const location = useLocation();

	if (location.pageType === PageType.PLP) {
		return <CategoryBreadcrumbs />;
	}

	return (
		<div className={cn('breadcrumbs-container', styles['breadcrumbs__container'])}>
			<ul className={cn(styles['breadcrumbs'], styles['breadcrumbs__list'])}>
				{!!prefixItems.length && prefixItems.map(item => (
					<li key={item.label} className={styles['breadcrumbs__item']}>
						<Breadcrumb {...item} classNames={styles['breadcrumbs__item-link']} />
					</li>
				))}
				{parentCategoryTree ? (
					parentCategoryTree.map((category, index: Number) => {
						const url = product?.getProductId() || parentCategoryTree.length !== +index + 1
							? category?.getUrl()
							: null;

						return (
							<li key={category?.getId()} className={styles['breadcrumbs__item']}>
								<Breadcrumb
									classNames={styles['breadcrumbs__item-link']}
									url={url}
									category={category}
									labelVariant={
										index === (parentCategoryTree.length - 1) && lastCategoryLabelVariant
											? lastCategoryLabelVariant
											: 'span'
									}
								/>
							</li>
						);
					})
				) : (
					<li className={styles['breadcrumbs__item']} />
				)}
				{showProductName && !!product && !!product?.getName() && (
					<li className={styles['breadcrumbs__item']}>
						<Breadcrumb label={product?.getName()} />
					</li>
				)}
			</ul>
		</div>
	);
};

export default Breadcrumbs;
